declare namespace $ {

	type $mol_paragraph__title_shm_hitalama_footer_1 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_image__uri_shm_hitalama_footer_2 = $mol_type_enforce<
		ReturnType< $shm_hitalama_footer['logo_uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $shm_hitalama_version_label__version_shm_hitalama_footer_3 = $mol_type_enforce<
		ReturnType< $shm_hitalama_footer['version'] >
		,
		ReturnType< $shm_hitalama_version_label['version'] >
	>
	type $shm_hitalama_version_label__date_shm_hitalama_footer_4 = $mol_type_enforce<
		ReturnType< $shm_hitalama_footer['date'] >
		,
		ReturnType< $shm_hitalama_version_label['date'] >
	>
	export class $shm_hitalama_footer extends $mol_view {
		Label( ): $mol_paragraph
		Logo( ): $mol_image
		version( ): string
		date( ): string
		Version( ): $shm_hitalama_version_label
		logo_uri( ): string
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=footer.view.tree.d.ts.map